export default __webpack_public_path__ + "static/media/camera-scan.7b376046.svg";